<template>
    <rkm-form
        ref="RkmForm"
    >
        <rkm-row>
            <rkm-col :cols="isForm ? 3 : 12">
                <rkm-form-input
                    :validations="validations.nomeFantasia"
                    label="Nome fantasia"
                    v-model="model.nomeFantasia"
                    uppercase
                />
            </rkm-col>

            <rkm-col :cols="isForm ? 9 : 12">
                <rkm-form-input-autocomplete
                    :searchFields="form.autocompleteFields.municipio"
                    :repository="repositories.municipio"
                    v-model="model.municipio"
                    label="Município"
                    :validations="validations.municipio"
                    uppercase
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { error, repository, stringCase, object } from '@/mixins'

export default {
    computed: {
        isForm() {
            return this.layout == 'form'
        },
        validations() {
            return {
                nomeFantasia: {
                    required: true,
                    min: 3,
                    max: 255,
                },
                municipio: { required: true  }
            }
        },
    },
    created() {
        this.repositories.unidadeExterna = this.getConectaSusRepository('cadastro.estabelecimento.unidadeExterna')
        this.repositories.municipio = this.getConectaSusRepository('intranet.municipio')
    },
    data: () => ({
        form: {
            autocompleteFields: {
                municipio: [
                    { key: 'nome', searchable: true },
                ],
            },
        },
        model: {
            nomeFantaisa: null,
            municipio: null
        },
        repositories: {
            unidadeExterna: null,
            municipio: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            if (!this.id) return

            this.setLoading()

            this.repositories.unidadeExterna.edit(this.id).then(response => {

                this.form = Object.assign(this.form, response.data.form)
                if(response.data.model) this.model = Object.assign(this.model, response.data.model)

            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate().then(response => {
                if (response === true) {
                    this.setLoading()

                    const data = this.clone(this.model)

                    data.municipioId = data.municipio.id

                    delete data.municipio

                    let request;
                    if (this.model.id) {
                        request = this.repositories.unidadeExterna.update(
                            this.model.id,
                            this.camelObjectKeysToSnakeRecursive(data)
                        )
                    } else {
                        request = this.repositories.unidadeExterna.store(
                            this.camelObjectKeysToSnakeRecursive(data)
                        )
                    }

                    request.then(response => {

                        this.showSaveNotification()
                        this.$emit('save', response.data)

                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
                }
            })
        },
    },
    mixins: [ error, repository, stringCase, object ],
    mounted() {
        this.load()
    },
    props: {
        id: { type: Number, default: null },
        layout: { type: String, default: 'form' }
    },
}
</script>